export default class ModalService {
  /* @ngInject */
  constructor($uibModal) {
    this.$uibModal = $uibModal;
  }

  invokeModal(component, resolve) {
    return this.$uibModal.open({
      animation: true,
      component,
      windowClass: 'zindex',
      resolve
    }).result
    // Stops a console error when the user clicks on the modal backdrop to dismiss the modal
    // https://github.com/angular-ui/bootstrap/issues/6501#issuecomment-330913656
    .catch((resp) => {
      if (['cancel', 'backdrop click', 'escape key press'].indexOf(resp) === -1) throw resp;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/modal.service.js